import { useState } from 'react'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import styled from 'styled-components'

import type { components } from '../../../constants/schema'

import { useWindowResize } from '../../../hooks/useWindowResize'

import { MAX_WIDTH } from '../Catalog'

import { Color } from '../../../theme/color'

import { ReactComponent as CloseIcon } from '../../../assets/ico/common/close/close_circle.svg'

interface CatalogImagesModal {
  images: Required<components['schemas']['CatalogDto']>['images']
  activeImageIndex: number
  toggleModal: () => void
}

export function CatalogImagesModal({ images, activeImageIndex: _activeImageIndex, toggleModal }: CatalogImagesModal) {
  const [activeImageIndex, setActiveImageIndex] = useState<number>(_activeImageIndex)

  const isBreak = useWindowResize(MAX_WIDTH)

  return (
    <Wrap isBreak={isBreak}>
      <CloseIcon onClick={toggleModal} />
      <TransformWrapper initialScale={1}>
        {({ resetTransform }) => (
          <>
            <Thumbnail>
              <TransformComponent>
                <img src={images[activeImageIndex].filePath} alt={images[activeImageIndex].filename} />
              </TransformComponent>
            </Thumbnail>
            <Footer>
              <Images>
                {images.map(({ id, filePath, filename }, index) => {
                  const isActive = index === activeImageIndex

                  const handleActiveImageIndex = () => {
                    resetTransform(0)
                    setActiveImageIndex(index)
                  }

                  return (
                    <ImageItem key={id} isActive={isActive} onClick={handleActiveImageIndex}>
                      <img src={filePath} alt={filename} />
                    </ImageItem>
                  )
                })}
              </Images>
            </Footer>
          </>
        )}
      </TransformWrapper>
    </Wrap>
  )
}

const Wrap = styled.div<{ isBreak: boolean }>`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100vw;
  height: 100vh;
  background-color: ${Color.white};
  > svg {
    position: absolute;
    top: 30px;
    right: ${({ isBreak }) => (isBreak ? '16px' : '100px')};
    z-index: 1;
    cursor: pointer;
  }
`

const Thumbnail = styled.div`
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  > * {
    width: 100% !important;
    height: 100% !important;
    > * {
      flex-wrap: initial;
      justify-content: center;
      width: fit-content;
      height: 100%;
      > img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
`

const Footer = styled.div`
  display: flex;
  justify-content: center;
  width: 100vw;
  background-color: ${Color.text_primary};
`

const Images = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: calc(100% / 70);
  max-width: 800px;
  padding: 24px 16px;
`

const ImageItem = styled.div<{ isActive: boolean }>`
  overflow: hidden;
  aspect-ratio: 1/1;
  ${({ isActive }) => (isActive ? `border: 2px solid ${Color.primary_5};` : '')}
  background-color: ${Color.white};
  cursor: pointer;
  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`
